import { API_URL } from "./api";
import { LabelingSample, LabelingTaskMeta } from "../types";

export interface LabelingTasksResponse {
  enabled: boolean;
  tasks: LabelingTaskMeta[];
}

const handleJson = async (response: Response) => {
  if (!response.ok) {
    const text = await response.text();
    throw new Error(`HTTP ${response.status} - ${response.statusText}: ${text}`);
  }
  return response.json();
};

export const fetchLabelingTasks = async (): Promise<LabelingTasksResponse> => {
  const response = await fetch(`${API_URL}/labeling/tasks`);
  const payload = (await handleJson(response)) as LabelingTasksResponse & {
    tasks: (LabelingTaskMeta & { imageUrl?: string })[];
  };

  return {
    ...payload,
    tasks: payload.tasks.map((task) => {
      const { imageUrl, ...rest } = task as LabelingTaskMeta & { imageUrl?: string };
      return {
        ...rest,
        image_url: task.image_url ?? imageUrl,
      };
    }),
  };
};

export const fetchLabelingTask = async (taskId: string): Promise<LabelingSample> => {
  const response = await fetch(`${API_URL}/labeling/tasks/${encodeURIComponent(taskId)}`);
  const payload = (await handleJson(response)) as LabelingSample & { imageUrl?: string };
  return { ...payload, image_url: payload.image_url ?? payload.imageUrl };
};

export const deleteLabelingTask = async (taskId: string): Promise<void> => {
  const response = await fetch(`${API_URL}/labeling/tasks/${encodeURIComponent(taskId)}`, {
    method: "DELETE",
  });
  await handleJson(response);
};

export const saveLabelingTask = async (taskId: string, payload: LabelingSample): Promise<void> => {
  const response = await fetch(`${API_URL}/labeling/tasks/${encodeURIComponent(taskId)}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  await handleJson(response);
};
